<script setup>
import { ref } from 'vue'

const banner_list = ref([
    {icon: require('@/assets/img/in-banner-icon-1.png'), cover: require('@/assets/img/in-banner-cover-1.png')},
    {icon: require('@/assets/img/in-banner-icon-2.png'), cover: require('@/assets/img/in-banner-cover-2.png')},
    {icon: require('@/assets/img/in-banner-icon-3.png'), cover: require('@/assets/img/in-banner-cover-3.png')},
    {icon: require('@/assets/img/in-banner-icon-4.png'), cover: require('@/assets/img/in-banner-cover-4.png')},
])

let banner_index = ref(0)
function bannerChange(index) {
    banner_index.value = index
}
</script>

<template>
    <section class="px-5 flex">
        <dl class="w-16 sm:w-24 pr-2 flex-shrink-0">
            <dd v-for="(item,index) in banner_list" :key="index" @click="bannerChange(index)" class="w-full mb-3 block">
                <img :src="item.icon" :class="index == banner_index ? 'shadow-md shadow-minor/50' : ''" class="w-full h-auto rounded-md block transition-all duration-300">
            </dd>
        </dl>
        <div class="h-72 sm:h-[420px] flex-1 overflow-hidden relative">
            <ul>
                <li v-for="(item,index) in banner_list" :key="index" :class="index == banner_index?'opacity-100':'opacity-0'" class="w-full h-full block transition-all duration-500 absolute left-0 top-0">
                    <img :src="item.cover" class="w-full h-full block">
                </li>
            </ul>
        </div>
    </section>
</template>